import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { EndCustomers } from "../end-customer/end-customer.entity";
import { Vendors } from "../vendors/vendors.entity";
import { ExchangeRates } from "../exchange-rates/exchange-rates.entity";

@Entity('currencies')
export class Currencies {

  @PrimaryGeneratedColumn("increment",{name:'currency_id'})
  currencyId:number;

  @Column("char",{
      nullable:false,
      length:50,
      name:"currency_name"
      })
  // @Index({ unique: true })
  currencyName:string;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;
  
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user",
    length:50
})
createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length:50
})
updatedUser: string | null;


  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  @OneToMany(type=>EndCustomers, endCustomers=>endCustomers.currencyInfo,{cascade: true})
  endCustomerInfo:EndCustomers[];

  @OneToMany(type=>Vendors, vendor=>vendor.currencyInfo,{cascade: true})
  vendorInfo:Vendors[];

  @OneToMany(type => ExchangeRates, exchange => exchange.currencyInfo, {cascade: true})
  exchangeInfo: ExchangeRates[]

}
